/**
 * Som do aviso de cupom sem confirmação.
 *
 * Diferente de propósito do som de pedido novo (`playOrderNotification`, dois
 * tons senoidais subindo): três bipes curtos, mais graves e em onda quadrada,
 * para quem está na cozinha distinguir "chegou pedido" de "o papel não saiu"
 * sem olhar a tela. Gerado pela Web Audio API, sem arquivo de áudio.
 */
export function playPrintingAlert(): void {
  try {
    const ctx = new AudioContext();
    const now = ctx.currentTime;

    for (const offset of [0, 0.22, 0.44]) {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'square';
      osc.frequency.value = 392; // G4
      gain.gain.setValueAtTime(0.12, now + offset);
      gain.gain.exponentialRampToValueAtTime(0.01, now + offset + 0.16);
      osc.connect(gain).connect(ctx.destination);
      osc.start(now + offset);
      osc.stop(now + offset + 0.16);
    }

    setTimeout(() => ctx.close(), 900);
  } catch {
    // Navegador sem áudio: o aviso na tela continua.
  }
}
